export default "__VITE_ASSET__ad781996__"